"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "terricciola": {
    "74b2acd3": [{
      "hkey": "69e8d4c0",
      "slug": "soiana-stibbiolo",
      "name": "Soiana-Stibbiolo",
      "primary": true,
      "skipSearch": false
    }],
    "soiana": [{
      "hkey": "69e8d4c0",
      "slug": "soiana-stibbiolo",
      "name": "Soiana-Stibbiolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "28c6bb1b": [{
      "hkey": "659e0cdb",
      "slug": "soianella-aia-bianca-le-case",
      "name": "Soianella-Aia Bianca-Le Case",
      "primary": true,
      "skipSearch": false
    }],
    "soianella": [{
      "hkey": "659e0cdb",
      "slug": "soianella-aia-bianca-le-case",
      "name": "Soianella-Aia Bianca-Le Case",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;